export enum MonthStartType {
NextMonth,
PurchaseDate,
}
